import {
  CustomerWebSocketProvider as ApiCustomerWebSocketProvider,
  useCurrentCustomer,
  UserWebSocketProvider as ApiUserWebSocketProvider,
} from '@billx/api';
import React from 'react';

import { useBusinessParams } from '@/hooks';

interface WebSocketProviderProps {
  children: React.ReactNode;
}

export const UserWebSocketProvider: React.FC<WebSocketProviderProps> = ({
  children,
}) => {
  return <ApiUserWebSocketProvider>{children}</ApiUserWebSocketProvider>;
};

export const CustomerWebSocketProvider: React.FC<WebSocketProviderProps> = ({
  children,
}) => {
  const { businessId } = useBusinessParams();
  const { currentCustomer } = useCurrentCustomer(businessId);

  return (
    <ApiCustomerWebSocketProvider
      businessId={currentCustomer?.businessId ?? ''}
      enabled={!!currentCustomer}
    >
      {children}
    </ApiCustomerWebSocketProvider>
  );
};
